import Alert from '@/components/shared/Alert';
import { type ErrorComponentProps } from '@tanstack/react-router';

type ErrorProps = Pick<ErrorComponentProps, 'error' | 'info'>;

export default function ErrorPage({ error, info }: ErrorProps) {
    if (info?.componentStack) {
        console.warn('Error component stack:', info.componentStack);
    }
    return (
        <div className="px-4 pt-4">
            <h1 className="fs-4 text-body mb-3">An error occurred</h1>
            <Alert variant="danger" >
                <p className="mb-0">{ error.message }</p>
            </Alert>
        </div>
    );
}